import { useTranslations } from "next-intl";

const TextInput = ({
	label,
	description,
	descriptionClassName,
	descriptionIcon,
	placeholder,
	id,
	name,
	parent_input_style,
	input_style,
	label_style,
	label_toolbar,
	required,
	type = "text",
	startAdornment,
	endAdornment,
	className,
	value,
	onChange,
	errors,
	errorClassName,
	autoComplete,
	disabled,
	focusRing = true,
	// اجازه می‌دهد یک اینپوت سفارشی (مثلا اینپوت مسک‌دار کد تایید) دقیقا داخل
	// همین قاب و با همان کلاس‌ها رندر شود تا ظاهر همه‌ی اینپوت‌ها یکی بماند
	input_render,
	...props
}) => {

	const t = useTranslations();
	const hasError = errors?.length > 0;
	const handle_input_change = (e) => {
		if (onChange) {
			onChange(e);
		}
	};

	const handle_error = (error) => {
		if (!error) return "";
		const error_key = error?.split(".")?.[1];
		const error_validations = error_key?.split("_");
		const error_name = error_validations?.[0];
		let error_validation = error_validations?.[1];
		if (error_validations?.length > 2) {
			error_validation = error_validations
				?.filter((_, index) => index > 0)
				.join("_");
		}
		if (error_name?.length === 24 && /^[A-F0-9]+$/i.test(error_name)) {
			return error_validation?.replace("attribute", label);
		}

		// validation keys ("validations.xxx") come from the shared validators,
		// show their translated message instead of the raw key
		if (typeof error === "string" && t.has(error)) {
			return t(error)?.replace("attribute", label);
		}

		return error;
	};

	return (
		<div className={`relative w-full mx-auto ${className || ""}`}>
			<div className="input-wrapper">

				{label && (
					<div className="label-parent w-full flex items-center justify-between gap-1 mb-1.5 min-h-5">
						<label
							htmlFor={id}
							className={`relative text-sm font-medium text-jmt-main ${label_style || ""}`}
						>
							{label}
							{required && (
								<span className="absolute top-0 -left-2.5 text-red-600">
									*
								</span>
							)}
						</label>
						{label_toolbar && label_toolbar}
					</div>
				)}

				<div
					className={`
    input-with-adornment flex items-center w-full border rounded-md overflow-hidden transition-all duration-200

    ${!hasError && !disabled
							? `border-jmt-neutral-300 hover:border-jmt-neutral-500
           ${focusRing ? "focus-within:border-jmt-neutral-600 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-jmt-neutral-600" : ""}`
							: ""
						}

    ${hasError ? "border-red-500 ring-jmt-red-500" : ""}
    ${disabled ? "bg-jmt-neutral-50 border-jmt-neutral-200 cursor-not-allowed" : ""}

    ${parent_input_style}
  `}
				>
					{startAdornment && (
						<div className="start-adornment ps-3 text-sm text-jmt-neutral-500">
							{startAdornment}
						</div>
					)}

					{(() => {
						const input_class_name = `
                            w-full bg-transparent outline-0 text-sm py-2 px-3
                            ${disabled ? 'text-jmt-neutral-400' : 'text-jmt-main'}
							${type === "number" ? "no-spinner" : ""}
                            ${input_style || ""}
                        `;

						const input_props = {
							placeholder,
							"aria-label": placeholder || label,
							name,
							id,
							value: value || "",
							disabled,
							autoComplete,
							className: input_class_name,
							...props,
						};

						if (typeof input_render === "function") {
							return input_render(input_props);
						}

						return (
							<input
								type={type}
								{...input_props}
								onChange={handle_input_change}
							/>
						);
					})()}

					{endAdornment && (
						<div className="end-adornment pe-3 text-sm text-jmt-neutral-500">
							{endAdornment}
						</div>
					)}
				</div>
			</div>

			<div className={`my-1.5 min-h-4 text-xs flex text-jmt-red-600 ${errorClassName}`}>
				{hasError ? (
					<span className="animate-fade">
						{typeof errors === "string" ?
							handle_error(errors)
							: handle_error(errors?.[0])
						}
					</span>
				) : description ? (
					<div
						className={`flex gap-1 ${descriptionClassName || ""}`}
					>
						{descriptionIcon && (
							<span className="shrink-0">
								{descriptionIcon}
							</span>
						)}

						<span>{description}</span>
					</div>
				) : null}
			</div>

		</div>
	);
};

export default TextInput;
